module.exports = __webpack_public_path__ + "img/blend4icon1.3a7be4c6.png";